<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="1000px"
        title="添加工单"
    >
        <el-form
            ref="addForm"
            :rules="rules"
            :model="addForm"
            label-width="100px"
        >
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="来源" size="small">
                        <el-select
                            v-model="addForm.project_id"
                            filterable
                            placeholder="请选择项目名称"
                            clearable
                        >
                            <el-option
                                v-for="item in projectList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="需求人"
                        prop="demand_user_id"
                        size="small"
                    >
                        <el-select
                            v-model="addForm.demand_user_id"
                            filterable
                            placeholder="请选择需求人"
                            clearable
                        >
                            <el-option
                                v-for="item in staffList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
              <el-form-item
                  label="类型"
                  size="small"
                  style="text-align: left"
                  :rules="{
                                required: true,
                                message: '请选择类型',
                                trigger: 'change',
                            }"
              >
                <el-radio-group
                    v-model="addForm.type"
                    size="mini"
                >
                  <el-radio :label="1">需求</el-radio>
                  <el-radio :label="2">BUG</el-radio>
                </el-radio-group>
              </el-form-item>
              </el-col>
              <el-col :span="12">
              <el-form-item
                  label="优先级"
                  size="small"
                  style="text-align: left"
                  :rules="{
                                required: true,
                                message: '请选择优先级',
                                trigger: 'change',
                            }"
              >
                <el-radio-group
                    v-model="addForm.priority"
                    size="mini"
                >
                  <el-radio :label="1">低</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">高</el-radio>
                </el-radio-group>
              </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item style="margin-bottom: 0; text-align: left">
                        <el-tag
                            class="order-tag"
                            type="warning"
                            v-for="item of tagsList"
                            :key="item.name"
                            @click="addTag(item)"
                            >{{ item.name }}</el-tag
                        >
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="工单名称" prop="name" size="small">
                        <el-input
                            ref="wordOrderNameInput"
                            clearable
                            placeholder="请输入工单名称"
                            maxlength="50"
                            size="small"
                            v-model="addForm.name"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="项目名称"
                        size="small"
                        prop="project_id"
                    >
                        <el-select
                            v-model="addForm.project_id"
                            placeholder="请选择项目名称"
                            clearable
                            filterable
                        >
                            <el-option
                                v-for="item in systemList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="任务名称" size="small" prop="job_id">
                        <el-select
                            v-model="addForm.project_id"
                            placeholder="请选择项目名称"
                            clearable
                            filterable
                        >
                            <el-option
                                v-for="item in systemList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="需求内容" size="small" prop="content">
                        <el-input
                            type="textarea"
                            placeholder="请输入需求内容"
                            maxlength="1000"
                            size="small"
                            v-model="addForm.content"
                            :autosize="{ minRows: 8, maxRows: 10 }"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="附件内容" size="small" prop="content">
                    <el-upload
                        class="upload-demo"
                        :headers="{token}"
                        :action="uploadUrl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :on-success="handleUpload"
                        :before-upload="beforeUpload"
                        multiple
                        :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">* 文件不超过 20MB</div>
                    </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label=" " size="small" prop="content">
                        <CustomImgUpload
                            :images="addForm.images || []"
                            @imagesChange="imagesChange"
                            ref="uploadRef"
                            :width="100"
                            :height="100"
                            :multiple="true"
                            :limit="99"
                            :readonly="false"
                        ></CustomImgUpload>
                    </el-form-item>
                </el-col>
            </el-row> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button id="saveSubmit" size="small" type="primary" @click="save(2)"
                >保存并提交</el-button
            >
            <el-button id="saveData" size="small" type="primary" @click="save(1)"
                >保存</el-button
            >
            <el-button size="small" @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import CustomImgUpload from "@/comon/components/CustomImgUpload/index.vue";
export default {
    data() {
        return {
            addForm: {
                name: "",
                project_id: "",
                content: "",
                demand_user_id: +localStorage.getItem("user_id"),
                type: 1,
                priority: 1,
                images: []
            },
            rules: {
                demand_user_id: [{ required: true, message: "请选择需求人" }],
                name: [{ required: true, message: "请输入工单名称" }],
                // status: [{ required: true, message: "请选择状态" }],
                // project_id: [{ required: false, message: "请选择项目名称" }],
                // job_id: [{ required: false, message: "请选择任务名称" }],
                // content: [{ required: false, message: "请输入详细描述" }],
            },
            projectList: [],
            tagsList: [
                {
                    name: "日常需求",
                    value: "【日常需求】",
                },
                {
                    name: "季度需求",
                    value: "【季度需求】",
                },
                {
                    name: "数据处理",
                    value: "【数据处理】",
                }
            ],
            token: localStorage.getItem('token'),
            uploadUrl: process.env.VUE_APP_BASE_API + '/v1/work-orders/upload',
            fileList: []
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm.images = [];
            this.fileList = [];
            this.$emit("update:addVisible", false);
        },
        /**
         *  保存
         */
        save(status) {
            this.$refs["addForm"].validate((valid) => {
              var saveSubmit = document.getElementById('saveSubmit');
              var saveData = document.getElementById('saveData');
              if (valid) {
                  saveSubmit.disabled = true; //使用true或false，控制是否让按钮禁用
                  saveData.disabled = true;
                    oaApi
                        .workOrdersList({ ...this.addForm, status }, "post")
                        .then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success("新增成功");
                                    this.$parent.workOrdersList();
                                }
                                this.closeDialog();
                            }
                          saveSubmit.disabled = false;
                          saveData.disabled = false;
                        });
                }
            });
        },
        addTag(item) {
            this.$refs.wordOrderNameInput.focus();
            if(this.addForm.name.indexOf(item.value)==-1){
                this.addForm.name += item.value;
            }
        },

        imagesChange(data) {
            this.addForm.images = data
        },
        handleRemove(file, fileList) {
            // console.log(file, fileList);
            const imgs = []
            fileList.forEach(item => {imgs.push(item.url)})
            this.addForm.images = imgs
        },
        handlePreview(file) {
            // console.log(file);
            window.open(file.url);
        },
        beforeRemove(file, fileList) {
            // return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleUpload(resp, file, fileList) {
            // set resp url to fileList
            fileList.map(item => {item.uid === file.uid && (item.url = resp.data.url); return item});
            console.log(resp, file, fileList);
            const imgs = [];
            fileList.forEach(item => {imgs.push(item.url)});
            this.addForm.images = imgs;
        },
        beforeUpload(file) {
            if (file.size / 1024 / 1024 > 20) {
                this.$message.warning(`${file.name} 文件大小超过 20MB`);
                return false;
            }
        }
    },
    props: {
        addVisible: Boolean,
        systemList: Array,
        projectList: () => {},
    },
    watch: {
        addVisible: {
            handler(val) {
                this.$parent.projectSelect();
            },
        },
    },
    computed: {
        staffList() {
            return this.$store.state.index.staffList;
        },
    },
    components: {
        CustomImgUpload,
    },
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-input--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
        .order-tag {
            cursor: pointer;
            user-select: none;
            &:hover {
                opacity: 0.85;
            }
            & + .order-tag {
                margin-left: 5px;
            }
        }
    }
    .upload-demo {
        text-align: left;
        .el-upload-list__item {
            width: max-content;
            transition: none;
            -webkit-transition: none;
            .el-icon-close-tip {
                display: none!important;
            }
        }
    }
}
</style>
